<script lang="ts">
    export let listItems : any;

</script>
<ul>
    {#each listItems as item}
        {#if item.listItem === "bullet"}
        <li>{@html item.children[0].text}</li>
        {/if}
    {/each}
</ul>